// components/MoviesCarousel.jsx
import React from "react";
import { MOVIES } from "../lib/data";

export default function MoviesCarousel() {
  const items = [...MOVIES, ...MOVIES];

  return (
    <div className="bg-white dark:bg-[#161b22]" style={{background : "rgb(var(--canvas))"}}>
      <p className="used-by-text text-center pt-8 pb-3">
        Composers trusted by the world's leading directors
      </p>
      <div className="studios-carousel-section">
        {/* Fade masks */}
        <div className="absolute left-0 top-0 bottom-0 w-1 z-10 pointer-events-none bg-gradient-to-r from-white dark:from-[#161b22] to-transparent" />
        <div className="absolute right-0 top-0 bottom-0 w-1 z-10 pointer-events-none bg-gradient-to-l from-white dark:from-[#161b22] to-transparent" />

        <div className="flex gap-2.5 marquee-rev pb-8 pt-2">
          {items.map(({ file, title }, i) => (
            <div
              key={`${file}-${i}`}
              className="movie-card h-full"
            >
              <img
                src={`/LandingSite/Movie_posters/${file}.jpg`}
                alt={`${title} — licensed music from SyncMama`}
                loading="lazy"
                className="object-cover block w-full h-full"
                onError={(e) => {
                  e.target.src = `https://placehold.co/120x180/1B3A6B/ffffff?text=${encodeURIComponent(title.slice(0, 12))}`;
                }}
              />
              {/* Hover overlay */}
              <div className="
                absolute inset-0 rounded-xl
                bg-gradient-to-t from-[rgba(10,15,30,0.9)] via-transparent to-transparent
                opacity-0 group-hover:opacity-100 transition-opacity duration-250
                flex items-end p-2
              ">
                <span className="text-[10px] font-semibold text-white text-center w-full">{title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
